import { render, staticRenderFns } from "./JobSeekerRequiredForm.vue?vue&type=template&id=7b5d3ee8&"
import script from "./JobSeekerRequiredForm.vue?vue&type=script&lang=js&"
export * from "./JobSeekerRequiredForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/workspace/components/Form/FormInput.vue').default,FormSelect: require('/workspace/components/Form/FormSelect.vue').default,FormInputNumber: require('/workspace/components/Form/FormInputNumber.vue').default,Form: require('/workspace/components/Form/index.js').default})
